import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sesa-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  @Input()
  message: String;
  @Input()
  backgroudColor: String = "alert alert-success alert-dismissible"
  constructor() { }

  ngOnInit() {
  }

}
